<template>
  <ul
    class="
      @768/layout/grid:4
      layout/flex:row
      layout/grid:2
      layout/grid:gap:page
      layout/width:100%
    "
    >
    <ArtistCard
      v-for="artist in artists"
      :id="artist.id"
      :key="artist.id"
      :display-date="artist.display_date"
      :exhibition-count="artist.exhibition_count"
      :name="artist.name"
      :object-count="artist.object_count"
    />
    <li
      v-if="totalCount > 3"
      class="layout/width:100%"
      >
      <a
        class="link/focus"
        data-gtm="clicks on artist"
        :href="`/artists/?q=${searchTerm}&with_online_works=true`"
        >
        <div
          class="
            layout/flex:column
            layout/width:100%
          "
          >
          <p
            class="$typography/size:medium $color/alpha:54% typography"
            v-html="i18n.t('collection__objects__list__artist-search-count', { Cnt: totalCount.toLocaleString() })"
          />
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
  /**
   * Artists Search List
   *
   * A list of artist tiles. A link tile renders if there is more than 3 artists returned.
   */
  import i18n from 'Utils/i18n.js';
  import ArtistCard from 'Components/collection-form/artist-card.vue';

  export default {
    components: {
      ArtistCard
    },

    props: {
      artists: { type: Array, required: true },
      searchTerm: { type: String, required: true },
      totalCount: { type: Number, required: true },
    },

    data() {
      return {
        i18n: new i18n(),
      };
    },
  };
</script>
